import { computed } from 'vue';
import { useSubNetworksStore } from '@/stores/subNetworksStore';

const useSubnetworkOptions = () => {
	const subNetworksStore = useSubNetworksStore();
	const subNetworkOptions = computed(() => subNetworksStore.subNetworkFilterOptions);
	const subNetworkSelectedId = computed({
		get: () => subNetworksStore.subNetworkSelectedId,
		set: value => subNetworksStore.updateSubNetworkSelectedId(value),
	})
	return {
		subNetworkOptions,
		subNetworkSelectedId,
	}
}

export { useSubnetworkOptions };
